module.exports = __webpack_public_path__ + "static/media/cq_messaggi.66648da0.svg";